import React, { useState, useEffect, useRef } from 'react';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Box, Dialog, DialogContent, DialogTitle, IconButton, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Grid } from '@mui/material';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from 'recharts';
import { Campaign, Project, formatDate, AuditScore, ProjectRadarData, AuditScoresResponse, ControlScore } from '../interFaces/interfaces';
import '../css/main/Home.css';
import "../css/others/Table.css";
import { apiCall } from '../main/ApiCall';
import CloseIcon from '@mui/icons-material/Close';
const PSDashboard: React.FC = () => {
  const [data, setData] = useState<{ campaignsData: any, functionCampaignsData: any, systemData: any, additionalCampaignsData: any, additionalFunctionCampaignsData: any, auditScoresData: AuditScoresResponse | null, summaryData: any } | null>(null);
  const [loading, setLoading] = useState({ campaignOverview: true, currentCampaign: true, systemActivity: true, closedCampaigns: true, functionCampaignOverview: true, currentFunctionCampaign: true, closedFunctionCampaigns: true, additionalCampaigns: true, additionalFunctionCampaigns: true, auditScores: true, normalAuditScores: true, integratedAuditScores: true, summary: true });
  const [error, setError] = useState({ campaignOverview: false, currentCampaign: false, systemActivity: false, closedCampaigns: false, functionCampaignOverview: false, currentFunctionCampaign: false, closedFunctionCampaigns: false, additionalCampaigns: false, additionalFunctionCampaigns: false, auditScores: false, normalAuditScores: false, integratedAuditScores: false, summary: false });
  const [selectedCampaign, setSelectedCampaign] = useState<Campaign | null>(null);
  const [selectedFunctionCampaign, setSelectedFunctionCampaign] = useState<Campaign | null>(null);
  const [selectedProject, setSelectedProject] = useState<{ projectId: string, auditId: string, projectName: string, campaignId: string, campaignName: string, checklistType: string } | null>(null);
  const [radarDialogOpen, setRadarDialogOpen] = useState(false);
  const [findingsDialogOpen, setFindingsDialogOpen] = useState(false);
  const [selectedProjectRadarData, setSelectedProjectRadarData] = useState<ProjectRadarData[]>([]);
  const [findingsData, setFindingsData] = useState<any>(null);
  const [findingsLoading, setFindingsLoading] = useState(false);
  const [integratedFindingsData, setIntegratedFindingsData] = useState<any>(null);
  const [integratedFindingsLoading, setIntegratedFindingsLoading] = useState(false);
  const clientId = localStorage.getItem("clientId");
  const email = localStorage.getItem("email");
  const isMounted = useRef(true);
  const timeoutRefs = useRef<NodeJS.Timeout[]>([]);
  const [selectedCampaignFilter, setSelectedCampaignFilter] = useState<string>("all");
  const [normalAuditScores, setNormalAuditScores] = useState<AuditScore[]>([]);
  const [integratedAuditScores, setIntegratedAuditScores] = useState<AuditScore[]>([]);
  const [normalCurrentPage, setNormalCurrentPage] = useState<number>(1);
  const [integratedCurrentPage, setIntegratedCurrentPage] = useState<number>(1);
  const [normalItemsPerPage, setNormalItemsPerPage] = useState<number>(5);
  const [integratedItemsPerPage, setIntegratedItemsPerPage] = useState<number>(5);
  const [normalTotalPages, setNormalTotalPages] = useState<number>(0);
  const [integratedTotalPages, setIntegratedTotalPages] = useState<number>(0);
  const [normalTotalElements, setNormalTotalElements] = useState<number>(0);
  const [integratedTotalElements, setIntegratedTotalElements] = useState<number>(0);
  const [allCampaignNames, setAllCampaignNames] = useState<string[]>([]);
  const COLORS = ['#FF6384', '#FF9F40', '#FFCD56', '#4BC0C0', '#36A2EB', '#9966FF', '#6d1629', '#C9CBCF'];
  const LoadingSpinner = ({ height = 200 }: { height?: number }) => (
    <Box display="flex" justifyContent="center" alignItems="center" height={height}>
      <CircularProgress />
    </Box>
  );
  useEffect(() => {
    isMounted.current = true;
    const fetchCampaignsData = async () => {
      try {
        setLoading(prev => ({ ...prev, campaignOverview: true, currentCampaign: true, closedCampaigns: true }));
        setError(prev => ({ ...prev, campaignOverview: false, currentCampaign: false, closedCampaigns: false }));
        let requestBody = [{ field: "clientId", operator: "=", value: clientId ?? "" }, { field: "createdBy", operator: "=", value: email ?? "" }];
        const campaignsData = await apiCall("post", `/api/dashboard/campaings`, requestBody);
        if (isMounted.current) {
          setData(prev => prev ? { ...prev, campaignsData } : { campaignsData, functionCampaignsData: null, systemData: null, additionalCampaignsData: null, additionalFunctionCampaignsData: null, auditScoresData: null, summaryData: null });
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, campaignOverview: false, currentCampaign: false, closedCampaigns: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, campaignOverview: true, currentCampaign: true, closedCampaigns: true }));
          setLoading(prev => ({ ...prev, campaignOverview: false, currentCampaign: false, closedCampaigns: false }));
        }
      }
    };
    const fetchFunctionCampaignsData = async () => {
      try {
        setLoading(prev => ({ ...prev, functionCampaignOverview: true, currentFunctionCampaign: true, closedFunctionCampaigns: true }));
        setError(prev => ({ ...prev, functionCampaignOverview: false, currentFunctionCampaign: false, closedFunctionCampaigns: false }));
        let requestBody = [{ field: "clientId", operator: "=", value: clientId ?? "" }, { field: "createdBy", operator: "=", value: email ?? "" }];
        const functionCampaignsData = await apiCall("post", `/api/dashboard/function/campaings`, requestBody);
        if (isMounted.current) {
          setData(prev => prev ? { ...prev, functionCampaignsData } : { campaignsData: null, functionCampaignsData, systemData: null, additionalCampaignsData: null, additionalFunctionCampaignsData: null, auditScoresData: null, summaryData: null });
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, functionCampaignOverview: false, currentFunctionCampaign: false, closedFunctionCampaigns: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, functionCampaignOverview: true, currentFunctionCampaign: true, closedFunctionCampaigns: true }));
          setLoading(prev => ({ ...prev, functionCampaignOverview: false, currentFunctionCampaign: false, closedFunctionCampaigns: false }));
        }
      }
    };
    const fetchSystemData = async () => {
      try {
        setLoading(prev => ({ ...prev, systemActivity: true }));
        setError(prev => ({ ...prev, systemActivity: false }));
        const systemData = await apiCall("get", `/api/dashboard/system?clientId=${clientId}`);
        if (isMounted.current) {
          setData(prev => prev ? { ...prev, systemData } : { campaignsData: null, functionCampaignsData: null, systemData, additionalCampaignsData: null, additionalFunctionCampaignsData: null, auditScoresData: null, summaryData: null });
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, systemActivity: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, systemActivity: true }));
          setLoading(prev => ({ ...prev, systemActivity: false }));
        }
      }
    };
    const fetchAdditionalCampaignsData = async () => {
      try {
        setLoading(prev => ({ ...prev, additionalCampaigns: true }));
        setError(prev => ({ ...prev, additionalCampaigns: false }));
        let clientOnlyRequestBody = [{ field: "clientId", operator: "=", value: clientId ?? "" }];
        const additionalCampaignsData = await apiCall("post", `/api/dashboard/campaings`, clientOnlyRequestBody);
        if (isMounted.current) {
          setData(prev => prev ? { ...prev, additionalCampaignsData } : { campaignsData: null, functionCampaignsData: null, systemData: null, additionalCampaignsData, additionalFunctionCampaignsData: null, auditScoresData: null, summaryData: null });
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, additionalCampaigns: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, additionalCampaigns: true }));
          setLoading(prev => ({ ...prev, additionalCampaigns: false }));
        }
      }
    };
    const fetchAdditionalFunctionCampaignsData = async () => {
      try {
        setLoading(prev => ({ ...prev, additionalFunctionCampaigns: true }));
        setError(prev => ({ ...prev, additionalFunctionCampaigns: false }));
        let clientOnlyRequestBody = [{ field: "clientId", operator: "=", value: clientId ?? "" }];
        const additionalFunctionCampaignsData = await apiCall("post", `/api/dashboard/function/campaings`, clientOnlyRequestBody);
        if (isMounted.current) {
          setData(prev => prev ? { ...prev, additionalFunctionCampaignsData } : { campaignsData: null, functionCampaignsData: null, systemData: null, additionalCampaignsData: null, additionalFunctionCampaignsData, auditScoresData: null, summaryData: null });
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, additionalFunctionCampaigns: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, additionalFunctionCampaigns: true }));
          setLoading(prev => ({ ...prev, additionalFunctionCampaigns: false }));
        }
      }
    };
    const fetchSummaryData = async () => {
      try {
        setLoading(prev => ({ ...prev, summary: true }));
        setError(prev => ({ ...prev, summary: false }));
        const clientOnlyPayload = [{ field: "clientId", operator: "=", value: clientId ?? "" }];
        const summaryData = await apiCall("post", `/api/dashboard/summary?clientId=${clientId}`, clientOnlyPayload);
        if (isMounted.current) {
          setData(prev => prev ? { ...prev, summaryData } : { campaignsData: null, functionCampaignsData: null, systemData: null, additionalCampaignsData: null, additionalFunctionCampaignsData: null, auditScoresData: null, summaryData });
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, summary: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, summary: true }));
          setLoading(prev => ({ ...prev, summary: false }));
        }
      }
    };
    Promise.all([fetchCampaignsData(), fetchFunctionCampaignsData(), fetchSystemData(), fetchAdditionalCampaignsData(), fetchAdditionalFunctionCampaignsData(), fetchSummaryData()]);
    return () => {
      isMounted.current = false;
      timeoutRefs.current.forEach(clearTimeout);
      timeoutRefs.current = [];
    };
  }, [clientId, email]);
  useEffect(() => {
    const fetchNormalAuditScores = async () => {
      try {
        setLoading(prev => ({ ...prev, normalAuditScores: true }));
        setError(prev => ({ ...prev, normalAuditScores: false }));
        const campaignParam = selectedCampaignFilter !== "all" ? `&campaignName=${encodeURIComponent(selectedCampaignFilter)}` : "";
        const normalData = await apiCall("get", `/api/dashboard/audit-scores?clientId=${clientId}&checklistType=NORMAL&page=${normalCurrentPage - 1}&size=${normalItemsPerPage}${campaignParam}`);
        if (isMounted.current && normalData) {
          setNormalTotalPages(normalData.totalPages);
          setNormalTotalElements(normalData.totalElements);
          setNormalAuditScores(normalData.content || []);
          if (normalData.content?.length) {
            setAllCampaignNames(prev => {
              const combined = new Set([...prev, ...normalData.content.map((a: AuditScore) => a.campaignName).filter(Boolean)]);
              return Array.from(combined).sort() as string[];
            });
          }
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, normalAuditScores: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, normalAuditScores: true }));
          setLoading(prev => ({ ...prev, normalAuditScores: false }));
        }
      }
    };
    fetchNormalAuditScores();
  }, [clientId, normalCurrentPage, normalItemsPerPage, selectedCampaignFilter]);
  useEffect(() => {
    const fetchIntegratedAuditScores = async () => {
      try {
        setLoading(prev => ({ ...prev, integratedAuditScores: true }));
        setError(prev => ({ ...prev, integratedAuditScores: false }));
        const campaignParam = selectedCampaignFilter !== "all" ? `&campaignName=${encodeURIComponent(selectedCampaignFilter)}` : "";
        const integratedData = await apiCall("get", `/api/dashboard/audit-scores?clientId=${clientId}&checklistType=INTEGRATED&page=${integratedCurrentPage - 1}&size=${integratedItemsPerPage}${campaignParam}`);
        if (isMounted.current && integratedData) {
          setIntegratedTotalPages(integratedData.totalPages);
          setIntegratedTotalElements(integratedData.totalElements);
          setIntegratedAuditScores(integratedData.content || []);
          if (integratedData.content?.length) {
            setAllCampaignNames(prev => {
              const combined = new Set([...prev, ...integratedData.content.map((a: AuditScore) => a.campaignName).filter(Boolean)]);
              return Array.from(combined).sort() as string[];
            });
          }
          const timeoutId = setTimeout(() => {
            if (isMounted.current) setLoading(prev => ({ ...prev, integratedAuditScores: false }));
          }, 300);
          timeoutRefs.current.push(timeoutId);
        }
      } catch (err) {
        if (isMounted.current) {
          setError(prev => ({ ...prev, integratedAuditScores: true }));
          setLoading(prev => ({ ...prev, integratedAuditScores: false }));
        }
      }
    };
    fetchIntegratedAuditScores();
  }, [clientId, integratedCurrentPage, integratedItemsPerPage, selectedCampaignFilter]);
  const handleCampaignFilterChange = (event: SelectChangeEvent) => {
    setSelectedCampaignFilter(event.target.value);
    setNormalCurrentPage(1);
    setIntegratedCurrentPage(1);
  };
  const handleCampaignClick = (campaign: Campaign) => {
    setSelectedCampaign(selectedCampaign?.campaignId === campaign.campaignId ? null : campaign);
  };
  const handleFunctionCampaignClick = (campaign: Campaign) => {
    setSelectedFunctionCampaign(selectedFunctionCampaign?.campaignId === campaign.campaignId ? null : campaign);
  };
  const handleProjectClick = async (projectId: string, auditId: string, projectName: string, checklistType: string, campaignId: string, campaignName: string) => {
    setSelectedProject({ projectId, auditId, projectName, campaignId, campaignName, checklistType });
    if (checklistType === "NORMAL") {
      await fetchFindingsData(campaignId, projectId);
    } else {
      const projectAudit = integratedAuditScores.find((audit: AuditScore) => audit.auditId === auditId && audit.projectId === projectId);
      if (projectAudit) {
        const auditScoreData = projectAudit.auditScoreData as any;
        const controlScores: ControlScore[] = auditScoreData?.controlScores || [];
        const radarData = controlScores.map((control: ControlScore) => ({ subject: control.controlType, score: control.score, weightedScore: control.weightedScore, fullMark: 5 }));
        setSelectedProjectRadarData(radarData);
        await fetchIntegratedFindingsData(campaignId, projectId);
        setRadarDialogOpen(true);
      }
    }
  };
  const fetchFindingsData = async (campaignId: string, projectId: string) => {
    try {
      setFindingsLoading(true);
      const response = await apiCall("get", `/api/dashboard/audit-scores/risk?campaignId=${campaignId}&projectId=${projectId}`);
      if (isMounted.current) {
        setFindingsData(response);
        setFindingsDialogOpen(true);
      }
    } catch (error) {
      console.error("Error fetching findings data:", error);
    } finally {
      setFindingsLoading(false);
    }
  };
  const fetchIntegratedFindingsData = async (campaignId: string, projectId: string) => {
    try {
      setIntegratedFindingsLoading(true);
      const response = await apiCall("get", `/api/dashboard/audit-scores/risk?campaignId=${campaignId}&projectId=${projectId}`);
      if (isMounted.current) {
        setIntegratedFindingsData(response);
      }
    } catch (error) {
      console.error("Error fetching integrated findings data:", error);
    } finally {
      setIntegratedFindingsLoading(false);
    }
  };
  const handleCloseRadarDialog = () => {
    setRadarDialogOpen(false);
    setSelectedProject(null);
    setSelectedProjectRadarData([]);
    setIntegratedFindingsData(null);
  };
  const handleCloseFindingsDialog = () => {
    setFindingsDialogOpen(false);
    setSelectedProject(null);
    setFindingsData(null);
  };
  const prepareChartData = (data: any, key: string) => {
    if (!data?.[key]) return [];
    return [
      { name: 'Completed', value: data[key].completed || 0, color: '#4CAF50' },
      { name: 'In Progress', value: data[key].inProgress || 0, color: '#FFC107' },
      { name: 'Not Started', value: data[key].notStarted || 0, color: '#F44336' }
    ].filter(item => item.value > 0);
  };
  const handleFirstPage = (type: 'normal' | 'integrated') => {
    if (type === 'normal') setNormalCurrentPage(1);
    else setIntegratedCurrentPage(1);
  };
  const handleLastPage = (type: 'normal' | 'integrated') => {
    if (type === 'normal') setNormalCurrentPage(normalTotalPages);
    else setIntegratedCurrentPage(integratedTotalPages);
  };
  const handleNextPage = (type: 'normal' | 'integrated', currentPage: number) => {
    const totalPages = type === 'normal' ? normalTotalPages : integratedTotalPages;
    if (currentPage < totalPages) {
      if (type === 'normal') setNormalCurrentPage(currentPage + 1);
      else setIntegratedCurrentPage(currentPage + 1);
    }
  };
  const handlePreviousPage = (type: 'normal' | 'integrated', currentPage: number) => {
    if (currentPage > 1) {
      if (type === 'normal') setNormalCurrentPage(currentPage - 1);
      else setIntegratedCurrentPage(currentPage - 1);
    }
  };
  const onPageChange = (type: 'normal' | 'integrated', page: number) => {
    if (type === 'normal') setNormalCurrentPage(page);
    else setIntegratedCurrentPage(page);
  };
  const handleItemsPerPageChange = (type: 'normal' | 'integrated', value: number) => {
    if (type === 'normal') {
      setNormalItemsPerPage(value);
      setNormalCurrentPage(1);
    } else {
      setIntegratedItemsPerPage(value);
      setIntegratedCurrentPage(1);
    }
  };
  const renderPagination = (type: 'normal' | 'integrated', currentPage: number, itemsPerPage: number, totalElements: number, totalPages: number) => {
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalElements);
    const pageNumbers = [];
    const maxPageNumbers = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2));
    let endPage = Math.min(totalPages, startPage + maxPageNumbers - 1);
    if (endPage - startPage + 1 < maxPageNumbers) startPage = Math.max(1, endPage - maxPageNumbers + 1);
    for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
    return (
      <div className="pagination">
        <button className="info">Showing {startItem} to {endItem} of {totalElements} items</button>
        <div className="pagination-controls">
          <button onClick={() => handleFirstPage(type)} className="pagination-btn" disabled={currentPage === 1}><span className="small-pipe">|</span>&#8249;</button>
          <button onClick={() => handlePreviousPage(type, currentPage)} className="pagination-btn" disabled={currentPage === 1}>&#8249;</button>
          {pageNumbers.map((page) => (
            <button key={`page-${type}-${page}`} onClick={() => onPageChange(type, page)} className={`pagination-btn ${currentPage === page ? "active" : ""}`}>{page}</button>
          ))}
          <button onClick={() => handleNextPage(type, currentPage)} className="pagination-btn" disabled={currentPage === totalPages}>&#8250;</button>
          <button onClick={() => handleLastPage(type)} className="pagination-btn" disabled={currentPage === totalPages}>&#8250;<span className="small-pipe">|</span></button>
        </div>
        <div>
          <select value={itemsPerPage} onChange={(e) => handleItemsPerPageChange(type, Number(e.target.value))} className="items-perpage-select">
            <option value={5}>5</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
    );
  };
  const getControlScoreByType = (auditScore: AuditScore, controlType: string) => {
    const auditScoreData = auditScore.auditScoreData as any;
    const controlScores: ControlScore[] = auditScoreData?.controlScores || [];
    return controlScores.find((control: ControlScore) => control.controlType === controlType);
  };
  const getAllControlTypes = (auditScores: AuditScore[]) => {
    if (!auditScores) return [];
    const allControlTypes = new Set<string>();
    auditScores.forEach((auditScore: AuditScore) => {
      const auditScoreData = auditScore.auditScoreData as any;
      const controlScores: ControlScore[] = auditScoreData?.controlScores || [];
      controlScores.forEach((control: ControlScore) => allControlTypes.add(control.controlType));
    });
    return Array.from(allControlTypes);
  };
  const formatWeightedScore = (weightedScore: number): string => `${weightedScore}%`;
  const getRatingClassName = (rating: string) => {
    if (!rating) return "rating-default";
    switch (rating.toLowerCase()) {
      case "high risk": return "rating-high-risk";
      case "needs improvement": return "rating-needs-improvement";
      case "satisfactory": return "rating-satisfactory";
      case "effective": return "rating-effective";
      case "optimized": return "rating-optimized";
      default: return "rating-default";
    }
  };
  const getFindingClassName = (findingType: string, value: number) => {
    if (value === 0) return "rating-zero";
    switch (findingType) {
      case "BEST_PRACTICE": return "rating-optimized";
      case "LARGELY_EFFECTIVE": return "rating-effective";
      case "NEEDS_IMPROVMENT": return "rating-needs-improvement";
      case "PARTIALLY_IMPLEMENTED": return "rating-partially-implemented";
      case "INITIAL_ADHOC": return "rating-initial-adhoc";
      case "NOT_IMPLEMENTED": return "rating-high-risk";
      default: return "rating-default";
    }
  };
  const findingOrder = ["BEST_PRACTICE", "LARGELY_EFFECTIVE", "NEEDS_IMPROVMENT", "PARTIALLY_IMPLEMENTED", "INITIAL_ADHOC", "NOT_IMPLEMENTED"];
  const campaignChartData = prepareChartData(data?.campaignsData, 'campaigns');
  const functionCampaignChartData = prepareChartData(data?.functionCampaignsData, 'campaigns');
  const additionalCampaignChartData = prepareChartData(data?.additionalCampaignsData, 'campaigns');
  const additionalFunctionCampaignChartData = prepareChartData(data?.additionalFunctionCampaignsData, 'campaigns');
  const auditChartData = prepareChartData(data?.campaignsData?.currentCampaign?.[0], 'audits');
  const functionAuditChartData = prepareChartData(data?.functionCampaignsData?.currentCampaign?.[0], 'audits');
  const systemActivityData = data?.systemData || {};
  const activeUsers = systemActivityData.activeUsers || {};
  const integratedControlTypes = getAllControlTypes(integratedAuditScores);
  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Primary Spoc Dashboard</h1>
        <div className="dashboard-last-login">Last login: {new Date().toLocaleString()}</div>
      </div>
      <nav className="admin-dashboard-section-title">Over All Campaigns View</nav>
      <div className="dashboard-grid">
        <Card className="dashboard-card">
          <h2 className="dashboard-card-title">Total Campaign Overview</h2>
          {loading.additionalCampaigns ? (
            <LoadingSpinner height={318} />
          ) : error.additionalCampaigns || !data?.additionalCampaignsData?.campaigns ? (
            <div className="no-data">No data available</div>
          ) : (
            <>
              <div className="dashboard-metric-row">
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value">{data.additionalCampaignsData.campaigns.total}</span>
                  <span className="dashboard-metric-label">Total Campaigns</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-not-started">{data.additionalCampaignsData.campaigns.notStarted}</span>
                  <span className="dashboard-metric-label">Not Started</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-in-progress">{data.additionalCampaignsData.campaigns.inProgress}</span>
                  <span className="dashboard-metric-label">In Progress</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-completed">{data.additionalCampaignsData.campaigns.completed}</span>
                  <span className="dashboard-metric-label">Completed</span>
                </div>
              </div>
              <div className="dashboard-chart-container">
                {additionalCampaignChartData.length > 0 ? (
                  <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                      <Pie data={additionalCampaignChartData} cx="50%" cy="50%" labelLine={false} outerRadius={35} fill="#8884d8" dataKey="value" label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}>
                        {additionalCampaignChartData.map((entry, index) => (
                          <Cell key={`additional-campaign-cell-${index}-${entry.name}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="no-data-chart">No data available for chart</div>
                )}
              </div>
            </>
          )}
        </Card>
        <Card className="dashboard-card">
          <h2 className="dashboard-card-title">Current Projects</h2>
          {loading.summary ? (
            <LoadingSpinner height={200} />
          ) : error.summary || !data?.summaryData?.currentProjectChanges ? (
            <div className="no-data">No data available</div>
          ) : (
            <>
              <div className="dashboard-metric-row">
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value">{data.summaryData.currentProjectChanges?.overall?.excluded ?? '0'}</span>
                  <span className="dashboard-metric-label">Excluded Projects (Overall)</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value">{data.summaryData.currentProjectChanges?.overall?.additional ?? '0'}</span>
                  <span className="dashboard-metric-label">Additional Projects (Overall)</span>
                </div>
              </div>
              <div className="dashboard-metric-row">
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value">{data.summaryData.currentProjectChanges?.currentCampaign?.excluded ?? '0'}</span>
                  <span className="dashboard-metric-label">Excluded Projects (Current Campaign)</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value">{data.summaryData.currentProjectChanges?.currentCampaign?.additional ?? '0'}</span>
                  <span className="dashboard-metric-label">Additional Projects (Current Campaign)</span>
                </div>
              </div>
            </>
          )}
        </Card>
      </div>
      <nav className="admin-dashboard-section-title">Individual Campaigns View</nav>
      <div className="dashboard-grid">
        <Card className="dashboard-card">
          <h2 className="dashboard-card-title">Campaign Overview</h2>
          {loading.campaignOverview ? (
            <LoadingSpinner height={318} />
          ) : error.campaignOverview || !data?.campaignsData?.campaigns ? (
            <div className="no-data">No data available</div>
          ) : (
            <>
              <div className="dashboard-metric-row">
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value">{data.campaignsData.campaigns.total}</span>
                  <span className="dashboard-metric-label">Total Campaigns</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-in-progress">{data.campaignsData.campaigns.inProgress}</span>
                  <span className="dashboard-metric-label">In Progress</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-completed">{data.campaignsData.campaigns.completed}</span>
                  <span className="dashboard-metric-label">Completed</span>
                </div>
              </div>
              <div className="dashboard-chart-container">
                {campaignChartData.length > 0 ? (
                  <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                      <Pie data={campaignChartData} cx="50%" cy="50%" labelLine={false} outerRadius={30} fill="#8884d8" dataKey="value" label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}>
                        {campaignChartData.map((entry, index) => (
                          <Cell key={`campaign-cell-${index}-${entry.name}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="no-data-chart">No data available for chart</div>
                )}
              </div>
            </>
          )}
        </Card>
        <Card className="dashboard-card">
          <h2 className="dashboard-card-title">Current Campaign: {loading.currentCampaign ? '' : (data?.campaignsData?.currentCampaign?.[0]?.name || 'No active campaign')}</h2>
          {loading.currentCampaign ? (
            <LoadingSpinner height={318} />
          ) : error.currentCampaign || !data?.campaignsData?.currentCampaign?.[0]?.audits ? (
            <div className="no-data">No data available</div>
          ) : (
            <>
              <div className="dashboard-metric-row">
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-completed">{data.campaignsData.currentCampaign[0].audits.completed}</span>
                  <span className="dashboard-metric-label">Completed</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-in-progress">{data.campaignsData.currentCampaign[0].audits.inProgress}</span>
                  <span className="dashboard-metric-label">In Progress</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-not-started">{data.campaignsData.currentCampaign[0].audits.notStarted}</span>
                  <span className="dashboard-metric-label">Not Started</span>
                </div>
              </div>
              <div className="dashboard-chart-container">
                {auditChartData.length > 0 ? (
                  <ResponsiveContainer width="95%" height={200}>
                    <BarChart data={auditChartData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="value">
                        {auditChartData.map((entry, index) => (
                          <Cell key={`audit-cell-${index}-${entry.name}`} fill={entry.color} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="no-data-chart">No audit data available</div>
                )}
              </div>
            </>
          )}
        </Card>
        <Card className="dashboard-card">
          <div className="dashboard-card-content">
            <h2 className="dashboard-card-title">System Activity</h2>
            {loading.systemActivity ? (
              <LoadingSpinner height={250} />
            ) : error.systemActivity || !data?.systemData ? (
              <div className="no-data">No data available</div>
            ) : (
              <>
                {[{ label: "Last Build Formula updated", value: systemActivityData.lastBuildFormulaUpdated }, { label: "Last Project Refresh", value: systemActivityData.lastProjectRefresh }, { label: "Last Roles Added", value: systemActivityData.lastRolesAdded }].map((item, index) => (
                  <div key={index} className="dashboard-system-item">
                    <span className="dashboard-system-label">{item.label}:</span>
                    <span className="dashboard-system-value">{item.value ? formatDate(item.value) : "Never"}</span>
                  </div>
                ))}
                {[{ label: "Active Super Admins", key: "superadmins" }, { label: "Active Primary SPOCs", key: "primaryspocs" }, { label: "Active Secondary SPOCs", key: "secondaryspocs" }, { label: "Active Admins", key: "admins" }, { label: "Active Auditors", key: "auditors" }, { label: "Active Quality Consultants", key: "qualityconsultants" }, { label: "Active Project Managers", key: "projectmanagers" }, { label: "Active Delivery Managers", key: "deliverymanagers" }, { label: "Active Test Managers", key: "testmanagers" }, { label: "Active Quality Managers", key: "qualitymanagers" }, { label: "Active Delivery Heads", key: "deliveryheads" }, { label: "Active Technical Leads", key: "technicalleads" }, { label: "Active Function Heads", key: "functionheads" }, { label: "Active Function SPOCs", key: "functionspocs" }].map((item, index) => (
                  <div key={index} className="dashboard-system-item">
                    <span className="dashboard-system-label">{item.label}:</span>
                    <span className="dashboard-system-value">{activeUsers[item.key] || 0}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        </Card>
        <Card className="dashboard-card dashboard-full-width-card">
          <h2 className="dashboard-card-title">Closed Campaigns</h2>
          {loading.closedCampaigns ? (
            <LoadingSpinner height={400} />
          ) : error.closedCampaigns || !data?.campaignsData?.closedCampaigns || data.campaignsData.closedCampaigns.length === 0 ? (
            <div className="no-data-available">No data available</div>
          ) : (
            <TableContainer component={Paper} className="campaigns-table-container">
              <Table>
                <TableHead className="campaigns-table-header">
                  <TableRow>
                    <TableCell>Campaign Name</TableCell>
                    <TableCell align="right">Total Projects</TableCell>
                    <TableCell align="right">Completed</TableCell>
                    <TableCell align="right">In Progress</TableCell>
                    <TableCell align="right">Not Started</TableCell>
                    <TableCell align="right">Not Implemented</TableCell>
                    <TableCell align="right">Initial / Adhoc</TableCell>
                    <TableCell align="right">Partially Implemented</TableCell>
                    <TableCell align="right">Implemented but Needs Improvement</TableCell>
                    <TableCell align="right">Largely Effective</TableCell>
                    <TableCell align="right">Best Practices</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="campaigns-table-body">
                  {data.campaignsData.closedCampaigns.map((campaign: Campaign) => {
                    const showDueDate = campaign.projects?.some((p: Project) => p.startDate);
                    return (
                      <React.Fragment key={`campaign-${campaign.campaignId}`}>
                        <TableRow hover onClick={() => handleCampaignClick(campaign)} className="campaign-body-row">
                          <TableCell>{campaign.name}</TableCell>
                          <TableCell align="right">{campaign.totalProjects}</TableCell>
                          <TableCell align="right">{campaign.completed}</TableCell>
                          <TableCell align="right">{campaign.inProgress}</TableCell>
                          <TableCell align="right">{campaign.notStarted}</TableCell>
                          <TableCell align="right">{campaign.notImplemented}</TableCell>
                          <TableCell align="right">{campaign.initialAdhoc}</TableCell>
                          <TableCell align="right">{campaign.partiallyImplemented}</TableCell>
                          <TableCell align="right">{campaign.improvements}</TableCell>
                          <TableCell align="right">{campaign.largelyEffective}</TableCell>
                          <TableCell align="right">{campaign.bestPractices}</TableCell>
                        </TableRow>
                        {selectedCampaign?.campaignId === campaign.campaignId && (
                          <TableRow className="project-drilldown-row">
                            <TableCell colSpan={11}>
                              <div className="campaign-projects-details">
                                <h4>Projects in {campaign.name}</h4>
                                <Table size="small">
                                  <TableHead className="project-table-header">
                                    <TableRow>
                                      <TableCell>Project Name</TableCell>
                                      <TableCell>Status</TableCell>
                                      {showDueDate && <TableCell>Due Date</TableCell>}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody className="project-table-body">
                                    {campaign.projects?.map((project: Project) => (
                                      <TableRow key={`project-${project.projectId}`}>
                                        <TableCell>{project.name}</TableCell>
                                        <TableCell>
                                          <span className={`status-badge status-${project.status.toLowerCase().replace(' ', '-')}`}>{project.status}</span>
                                        </TableCell>
                                        {showDueDate && <TableCell>{project.startDate || '-'}</TableCell>}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </div>
      <nav className="admin-dashboard-section-title">Integrated Audit Performance Scores</nav>
      <Card className="dashboard-card dashboard-full-width-card">
        <div className="audit-scores-header">
          <h2 className="dashboard-card-title">Integrated Audit Scores</h2>
          <FormControl className="campaign-filter-control" size="small">
            <InputLabel id="integrated-campaign-filter-label">Select Campaign</InputLabel>
            <Select labelId="integrated-campaign-filter-label" id="integrated-campaign-filter" value={selectedCampaignFilter} label="Select Campaign" onChange={handleCampaignFilterChange}>
              <MenuItem value="all">All Campaigns</MenuItem>
              {allCampaignNames.map((campaignName) => (
                <MenuItem key={campaignName} value={campaignName}>{campaignName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {loading.integratedAuditScores ? (
          <LoadingSpinner height={400} />
        ) : error.integratedAuditScores || integratedAuditScores.length === 0 ? (
          <div className="no-data-available">No integrated audit scores data available{selectedCampaignFilter !== "all" ? ` for campaign: ${selectedCampaignFilter}` : ''}</div>
        ) : (
          <>
            <TableContainer component={Paper} className="campaigns-table-container">
              <Table>
                <TableHead className="campaigns-table-header">
                  <TableRow>
                    <TableCell>Campaign Name</TableCell>
                    <TableCell>Project Name</TableCell>
                    <TableCell align="right">Overall Score</TableCell>
                    <TableCell align="center">Overall Rating</TableCell>
                    {integratedControlTypes.map((controlType, index) => (
                      <React.Fragment key={`control-header-${controlType}-${index}`}>
                        <TableCell align="right">{controlType} Weighted</TableCell>
                        <TableCell align="center">{controlType} Rating</TableCell>
                      </React.Fragment>
                    ))}
                    <TableCell align="center">View Radar & Findings</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="campaigns-table-body">
                  {integratedAuditScores.map((auditScore: AuditScore, index: number) => {
                    const auditScoreData = auditScore.auditScoreData as any;
                    const overallScore = auditScoreData?.overallScore || 0;
                    const overallRating = auditScoreData?.overallRating || 'N/A';
                    const overallRatingClassName = getRatingClassName(overallRating);
                    return (
                      <TableRow key={`integrated-audit-${auditScore.auditId || index}`} hover className="campaign-body-row">
                        <TableCell>{auditScore.campaignName}</TableCell>
                        <TableCell>{auditScore.projectName}</TableCell>
                        <TableCell align="right"><span className="overall-score">{overallScore.toFixed(2)}%</span></TableCell>
                        <TableCell align="center"><span className={`rating-badge ${overallRatingClassName}`}>{overallRating}</span></TableCell>
                        {integratedControlTypes.map((controlType) => {
                          const control = getControlScoreByType(auditScore, controlType);
                          const ratingClassName = getRatingClassName(control?.rating || '');
                          return (
                            <React.Fragment key={`control-body-${controlType}-${auditScore.auditId || index}`}>
                              <TableCell align="right">
                                <span className="weighted-score">{control ? formatWeightedScore(control.weightedScore) : 'N/A'}</span>
                              </TableCell>
                              <TableCell align="center">
                                <span className={`rating-badge ${ratingClassName}`}>{control?.rating || 'N/A'}</span>
                              </TableCell>
                            </React.Fragment>
                          );
                        })}
                        <TableCell align="center">
                          <button className="radar-view-button" onClick={() => handleProjectClick(auditScore.projectId, auditScore.auditId, auditScore.projectName, auditScore.checklistType, auditScore.campaignId, auditScore.campaignName)}>View Radar & Findings</button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {renderPagination('integrated', integratedCurrentPage, integratedItemsPerPage, integratedTotalElements, integratedTotalPages)}
          </>
        )}
      </Card>
      <nav className="admin-dashboard-section-title">Normal Audit Performance Scores</nav>
      <Card className="dashboard-card dashboard-full-width-card">
        <div className="audit-scores-header">
          <h2 className="dashboard-card-title">Normal Audit Scores</h2>
          <FormControl className="campaign-filter-control" size="small">
            <InputLabel id="normal-campaign-filter-label">Select Campaign</InputLabel>
            <Select labelId="normal-campaign-filter-label" id="normal-campaign-filter" value={selectedCampaignFilter} label="Select Campaign" onChange={handleCampaignFilterChange}>
              <MenuItem value="all">All Campaigns</MenuItem>
              {allCampaignNames.map((campaignName) => (
                <MenuItem key={campaignName} value={campaignName}>{campaignName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {loading.normalAuditScores ? (
          <LoadingSpinner height={400} />
        ) : error.normalAuditScores || normalAuditScores.length === 0 ? (
          <div className="no-data-available">No normal audit scores data available{selectedCampaignFilter !== "all" ? ` for campaign: ${selectedCampaignFilter}` : ''}</div>
        ) : (
          <>
            <TableContainer component={Paper} className="campaigns-table-container">
              <Table>
                <TableHead className="campaigns-table-header">
                  <TableRow>
                    <TableCell>Campaign Name</TableCell>
                    <TableCell>Project Name</TableCell>
                    <TableCell align="right">Overall Score</TableCell>
                    <TableCell align="center">Overall Rating</TableCell>
                    <TableCell align="center">View Findings</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="campaigns-table-body">
                  {normalAuditScores.map((auditScore: AuditScore, index: number) => {
                    const auditScoreData = auditScore.auditScoreData as any;
                    const overallScore = auditScoreData?.overallScore || 0;
                    const overallRating = auditScoreData?.overallRating || 'N/A';
                    const overallRatingClassName = getRatingClassName(overallRating);
                    return (
                      <TableRow key={`normal-audit-${auditScore.auditId || index}`} hover className="campaign-body-row">
                        <TableCell>{auditScore.campaignName}</TableCell>
                        <TableCell>{auditScore.projectName}</TableCell>
                        <TableCell align="right"><span className="overall-score">{overallScore.toFixed(2)}%</span></TableCell>
                        <TableCell align="center"><span className={`rating-badge ${overallRatingClassName}`}>{overallRating}</span></TableCell>
                        <TableCell align="center">
                          <button className="radar-view-button" onClick={() => handleProjectClick(auditScore.projectId, auditScore.auditId, auditScore.projectName, auditScore.checklistType, auditScore.campaignId, auditScore.campaignName)}>View Findings</button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {renderPagination('normal', normalCurrentPage, normalItemsPerPage, normalTotalElements, normalTotalPages)}
          </>
        )}
      </Card>
      <Dialog open={radarDialogOpen} onClose={handleCloseRadarDialog} maxWidth="xl" fullWidth>
        <DialogTitle className="radar-dialog-title">
          <div className="radar-dialog-header">
            <span>Control Performance - Project: {selectedProject?.projectName}</span>
            <IconButton onClick={handleCloseRadarDialog} className="close-button"><CloseIcon /></IconButton>
          </div>
        </DialogTitle>
        <DialogContent className="radar-dialog-content">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Control Performance Radar</h3>
              {selectedProjectRadarData.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                  <RadarChart cx="50%" cy="50%" outerRadius="80%" data={selectedProjectRadarData}>
                    <PolarGrid gridType="polygon" />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis angle={30} domain={[0, 5]} tickCount={7} />
                    <Radar name="Score" dataKey="score" stroke="#8884d8" strokeWidth={2} fill="#8884d8" fillOpacity={0.3} dot={(props: any) => {
                      const { cx, cy, index } = props;
                      return <circle key={index} cx={cx} cy={cy} r={5} fill={COLORS[index % COLORS.length]} stroke="#fff" strokeWidth={1} />;
                    }} />
                    <Radar name="Weighted Score" dataKey="weightedScore" stroke="#82ca9d" strokeWidth={2} fill="#82ca9d" fillOpacity={0.3} dot={(props: any) => {
                      const { cx, cy, index } = props;
                      return <circle key={index} cx={cx} cy={cy} r={5} fill={COLORS[index % COLORS.length]} stroke="#fff" strokeWidth={1} />;
                    }} />
                    <Legend />
                    <Tooltip formatter={(value: number, name: string) => [value.toFixed(2), name]} />
                  </RadarChart>
                </ResponsiveContainer>
              ) : (
                <div className="no-data">No radar data available for this project</div>
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Findings by Control Type</h3>
              {integratedFindingsLoading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height={300}><CircularProgress /></Box>
              ) : integratedFindingsData?.findingsByControls && Object.keys(integratedFindingsData.findingsByControls).length > 0 ? (
                <TableContainer component={Paper} style={{ maxHeight: 400 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Control Type</TableCell>
                        <TableCell align="center">Best Practice</TableCell>
                        <TableCell align="center">Largely Effective</TableCell>
                        <TableCell align="center">Needs Improvement</TableCell>
                        <TableCell align="center">Partially Implemented</TableCell>
                        <TableCell align="center">Initial / Adhoc</TableCell>
                        <TableCell align="center">Not Implemented</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.entries(integratedFindingsData.findingsByControls).map(([controlType, findings]: [string, any]) => (
                        <TableRow key={controlType}>
                          <TableCell component="th" scope="row"><strong>{controlType}</strong></TableCell>
                          {findingOrder.map((findingKey) => (
                            <TableCell key={`${controlType}-${findingKey}`} align="center" className={getFindingClassName(findingKey, findings[findingKey] || 0)}>{findings[findingKey] || 0}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div className="no-data">No findings data available for this project</div>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog open={findingsDialogOpen} onClose={handleCloseFindingsDialog} maxWidth="lg" fullWidth>
        <DialogTitle className="radar-dialog-title">
          <div className="radar-dialog-header">
            <span>Findings - Project: {selectedProject?.projectName} (Campaign: {selectedProject?.campaignName})</span>
            <IconButton onClick={handleCloseFindingsDialog} className="close-button"><CloseIcon /></IconButton>
          </div>
        </DialogTitle>
        <DialogContent className="radar-dialog-content">
          {findingsLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}><CircularProgress /></Box>
          ) : findingsData?.findingsByPracticeArea && Object.keys(findingsData.findingsByPracticeArea).length > 0 ? (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Practice Area</TableCell>
                    <TableCell align="center">Best Practice</TableCell>
                    <TableCell align="center">Largely Effective</TableCell>
                    <TableCell align="center">Needs Improvement</TableCell>
                    <TableCell align="center">Partially Implemented</TableCell>
                    <TableCell align="center">Initial / Adhoc</TableCell>
                    <TableCell align="center">Not Implemented</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(findingsData.findingsByPracticeArea).map(([practiceArea, findings]: [string, any]) => (
                    <TableRow key={practiceArea}>
                      <TableCell component="th" scope="row"><strong>{practiceArea}</strong></TableCell>
                      {findingOrder.map((findingKey) => (
                        <TableCell key={`${practiceArea}-${findingKey}`} align="center" className={getFindingClassName(findingKey, findings[findingKey] || 0)}>{findings[findingKey] || 0}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div className="no-data">No findings data available for this project</div>
          )}
        </DialogContent>
      </Dialog>
      <nav className="admin-dashboard-section-title">Over All Function Campaigns View</nav>
      <Card className="dashboard-card">
        <h2 className="dashboard-card-title">Total Function Campaign Overview</h2>
        {loading.additionalFunctionCampaigns ? (
          <LoadingSpinner height={318} />
        ) : error.additionalFunctionCampaigns || !data?.additionalFunctionCampaignsData?.campaigns ? (
          <div className="no-data">No data available</div>
        ) : (
          <>
            <div className="dashboard-metric-row">
              <div className="dashboard-metric-item">
                <span className="dashboard-metric-value">{data.additionalFunctionCampaignsData.campaigns.total}</span>
                <span className="dashboard-metric-label">Total Campaigns</span>
              </div>
              <div className="dashboard-metric-item">
                <span className="dashboard-metric-value dashboard-metric-value-not-started">{data.additionalFunctionCampaignsData.campaigns.notStarted}</span>
                <span className="dashboard-metric-label">Not Started</span>
              </div>
              <div className="dashboard-metric-item">
                <span className="dashboard-metric-value dashboard-metric-value-in-progress">{data.additionalFunctionCampaignsData.campaigns.inProgress}</span>
                <span className="dashboard-metric-label">In Progress</span>
              </div>
              <div className="dashboard-metric-item">
                <span className="dashboard-metric-value dashboard-metric-value-completed">{data.additionalFunctionCampaignsData.campaigns.completed}</span>
                <span className="dashboard-metric-label">Completed</span>
              </div>
            </div>
            <div className="dashboard-chart-container">
              {additionalFunctionCampaignChartData.length > 0 ? (
                <ResponsiveContainer width="90%" height={200}>
                  <PieChart>
                    <Pie data={additionalFunctionCampaignChartData} cx="50%" cy="50%" labelLine={false} outerRadius={35} fill="#8884d8" dataKey="value" label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}>
                      {additionalFunctionCampaignChartData.map((entry, index) => (
                        <Cell key={`additional-function-campaign-cell-${index}-${entry.name}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              ) : (
                <div className="no-data-chart">No data available for chart</div>
              )}
            </div>
          </>
        )}
      </Card>
      <nav className="admin-dashboard-section-title">Individual Function Campaigns View</nav>
      <div className="dashboard-grid">
        <Card className="dashboard-card">
          <h2 className="dashboard-card-title">Function Campaign Overview</h2>
          {loading.functionCampaignOverview ? (
            <LoadingSpinner height={318} />
          ) : error.functionCampaignOverview || !data?.functionCampaignsData?.campaigns ? (
            <div className="no-data">No data available</div>
          ) : (
            <>
              <div className="dashboard-metric-row">
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value">{data.functionCampaignsData.campaigns.total}</span>
                  <span className="dashboard-metric-label">Total Campaigns</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-in-progress">{data.functionCampaignsData.campaigns.inProgress}</span>
                  <span className="dashboard-metric-label">In Progress</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-completed">{data.functionCampaignsData.campaigns.completed}</span>
                  <span className="dashboard-metric-label">Completed</span>
                </div>
              </div>
              <div className="dashboard-chart-container">
                {functionCampaignChartData.length > 0 ? (
                  <ResponsiveContainer width="90%" height={200}>
                    <PieChart>
                      <Pie data={functionCampaignChartData} cx="50%" cy="50%" labelLine={false} outerRadius={35} fill="#8884d8" dataKey="value" label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}>
                        {functionCampaignChartData.map((entry, index) => (
                          <Cell key={`function-campaign-cell-${index}-${entry.name}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="no-data-chart">No data available for chart</div>
                )}
              </div>
            </>
          )}
        </Card>
        <Card className="dashboard-card">
          <h2 className="dashboard-card-title">Current Function Campaign: {loading.currentFunctionCampaign ? '' : (data?.functionCampaignsData?.currentCampaign?.[0]?.name || 'No active function campaign')}</h2>
          {loading.currentFunctionCampaign ? (
            <LoadingSpinner height={318} />
          ) : error.currentFunctionCampaign || !data?.functionCampaignsData?.currentCampaign?.[0]?.audits ? (
            <div className="no-data">No data available</div>
          ) : (
            <>
              <div className="dashboard-metric-row">
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-completed">{data.functionCampaignsData.currentCampaign[0].audits.completed}</span>
                  <span className="dashboard-metric-label">Completed</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-in-progress">{data.functionCampaignsData.currentCampaign[0].audits.inProgress}</span>
                  <span className="dashboard-metric-label">In Progress</span>
                </div>
                <div className="dashboard-metric-item">
                  <span className="dashboard-metric-value dashboard-metric-value-not-started">{data.functionCampaignsData.currentCampaign[0].audits.notStarted}</span>
                  <span className="dashboard-metric-label">Not Started</span>
                </div>
              </div>
              <div className="dashboard-chart-container">
                {functionAuditChartData.length > 0 ? (
                  <ResponsiveContainer width="95%" height={200}>
                    <BarChart data={functionAuditChartData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="value">
                        {functionAuditChartData.map((entry, index) => (
                          <Cell key={`function-audit-cell-${index}-${entry.name}`} fill={entry.color} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                ) : (
                  <div className="no-data">No audit data available</div>
                )}
              </div>
            </>
          )}
        </Card>
      </div>
      <div className="mt-20">
        <Card className="dashboard-card dashboard-full-width-card">
          <h2 className="dashboard-card-title">Closed Function Campaigns</h2>
          {loading.closedFunctionCampaigns ? (
            <LoadingSpinner height={400} />
          ) : error.closedFunctionCampaigns || !data?.functionCampaignsData?.closedCampaigns || data.functionCampaignsData.closedCampaigns.length === 0 ? (
            <div className="no-data-available">No data available</div>
          ) : (
            <TableContainer component={Paper} className="campaigns-table-container">
              <Table>
                <TableHead className="campaigns-table-header">
                  <TableRow>
                    <TableCell>Campaign Name</TableCell>
                    <TableCell align="right">Total Projects</TableCell>
                    <TableCell align="right">Completed</TableCell>
                    <TableCell align="right">In Progress</TableCell>
                    <TableCell align="right">Not Started</TableCell>
                    <TableCell align="right">Not Implemented</TableCell>
                    <TableCell align="right">Initial / Adhoc</TableCell>
                    <TableCell align="right">Partially Implemented</TableCell>
                    <TableCell align="right">Implemented but Needs Improvement</TableCell>
                    <TableCell align="right">Largely Effective</TableCell>
                    <TableCell align="right">Best Practices</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="campaigns-table-body">
                  {data.functionCampaignsData.closedCampaigns.map((campaign: Campaign) => {
                    const showDueDate = campaign.projects?.some((p: Project) => p.startDate);
                    return (
                      <React.Fragment key={`function-campaign-${campaign.campaignId}`}>
                        <TableRow hover onClick={() => handleFunctionCampaignClick(campaign)} className="campaign-body-row">
                          <TableCell>{campaign.name}</TableCell>
                          <TableCell align="right">{campaign.totalProjects}</TableCell>
                          <TableCell align="right">{campaign.completed}</TableCell>
                          <TableCell align="right">{campaign.inProgress}</TableCell>
                          <TableCell align="right">{campaign.notStarted}</TableCell>
                          <TableCell align="right">{campaign.notImplemented}</TableCell>
                          <TableCell align="right">{campaign.initialAdhoc}</TableCell>
                          <TableCell align="right">{campaign.partiallyImplemented}</TableCell>
                          <TableCell align="right">{campaign.improvements}</TableCell>
                          <TableCell align="right">{campaign.largelyEffective}</TableCell>
                          <TableCell align="right">{campaign.bestPractices}</TableCell>
                        </TableRow>
                        {selectedFunctionCampaign?.campaignId === campaign.campaignId && (
                          <TableRow className="project-drilldown-row">
                            <TableCell colSpan={11}>
                              <div className="campaign-projects-details">
                                <h4>Functions in {campaign.name}</h4>
                                <Table size="small">
                                  <TableHead className="project-table-header">
                                    <TableRow>
                                      <TableCell>Function Name</TableCell>
                                      <TableCell>Status</TableCell>
                                      {showDueDate && <TableCell>Due Date</TableCell>}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody className="project-table-body">
                                    {campaign.projects?.map((project: Project) => (
                                      <TableRow key={`function-project-${project.projectId}`}>
                                        <TableCell>{project.name}</TableCell>
                                        <TableCell>
                                          <span className={`status-badge status-${project.status.toLowerCase().replace(' ', '-')}`}>{project.status}</span>
                                        </TableCell>
                                        {showDueDate && <TableCell>{project.startDate || '-'}</TableCell>}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </div>
    </div>
  );
};
export default PSDashboard;